import React  from 'react';
import { Link } from 'react-router-dom';
function Games() {
    return (
        <div className="container">
            <div className="row"  >
                < div className="col">
                    <h1>Games</h1>
                    <p>Some games I have written using react.</p>
                 
                     </div>
            </div>
            <div className="row"> <div className="col">
                <ul>
                <li>
                    <Link to="/Poker">5 Card Poker</Link>
                    </li>
                </ul>

            </div></div>
        </div>);

}

export default Games